import React from 'react'
import { Box } from '@mui/material';
import { useLoggedContext } from '../../Auth/AuthContext';
import './header.css';
import { Link } from 'react-router-dom';

const Header = () => {

    const { auth, setAuth } = useLoggedContext();

    const logout = () => {
        localStorage.clear();
        setAuth(false);
    }
    return (
        <Box className='header'>
            <Box className="link-container">
                <Link to="/">Home</Link>
                <Link to="/configurations/driver">Configurazioni</Link>
            </Box>

            <Box className="logout-button-container">
                <button onClick={logout} className="logout-button agriverse-button-green">
                    Logout
                </button>
            </Box>

        </Box>
    )
}

export default Header;